<template>
  <div class="sitebuilder-element-container"
       element="YoutubeVideoComponent"
       :data-tag="dataTag()"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile" :id="id"

       :style="style()">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe :width="internal_config.width" :height="internal_config.height" :src="getUrl()"
                :data-src="getDataUrl()"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen class="embed-responsive-item"
                v-bind:style="{'border-radius': radius,border : border}">
        </iframe>
      </div>
  </div>
</template>
<script>

	import Model from './Model';

	export default {
		name: 'YoutubeVideoComponent',
		components: {
			Model,

		},
		props: ['config', 'height_start', 'device', 'id', 'preview', 'is_popup'],
		data() {
			return Model.data()
		},
		computed: {
			width() {
				return this.internal_config.width;
			},
			height() {
				return this.internal_config.height;
			},
			border() {
				if (typeof this.internal_config.border !== 'undefined') {
					let splitedBorder = this.internal_config.border.split(' ');

					if (typeof splitedBorder[2] !== 'undefined' && this.$globalStoreHelpers.isValidHex(splitedBorder[2])) {
						splitedBorder[2] = this.$globalStoreHelpers.hexToRGBA(splitedBorder[2]);
						this.internal_config.border = splitedBorder.join(' ');
					}
				}
				return this.internal_config.border;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
		},
		methods: {
			dataTag(){
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},
            getDataUrl(){
				if(this.is_popup == true){
					let url = this.internal_config.src;
					if (this.internal_config.checkBoxAutoPlay) {
						url = url + '&autoplay=1'
					}
					if (this.internal_config.checkBoxLoop) {
						url = url + '&loop=1'
					}
					if (this.internal_config.checkBoxControl) {
						url = url + '&controls=0'
					}
					url = url + "&start=" + this.internal_config.startYoutube + "&end=" + this.internal_config.endYoutube;

					return url;
				}
            },
			getUrl() {

				if(this.is_popup == true){
					return  null;
                }

				let url = this.internal_config.src;
				if (this.internal_config.checkBoxAutoPlay) {
					url = url + '&autoplay=1'
				}
				if (this.internal_config.checkBoxLoop) {
					url = url + '&loop=1'
				}
				if (this.internal_config.checkBoxControl) {
					url = url + '&controls=0'
				}
				url = url + "&start=" + this.internal_config.startYoutube + "&end=" + this.internal_config.endYoutube;

				return url;
			},
			style() {
				let style = `left:  ${this.internal_config.left};
                     width: ${this.internal_config.width};
                     height: ${this.internal_config.height};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
				return style;
			},
		},
		mounted() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);


			this.internal_config = config;
			this.device = device;

			if (typeof id !== 'undefined') {
				this.id = id;
			}


			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

		}
	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .vdr{
    height: auto !important;
  }
</style>
